module.exports = __webpack_public_path__ + "img/portrait_correct.966ee82f.png";